<template>
  <div id="app" :class="{ 'no-scroll': cookiesBanner && !$route.meta.allowNoCookie }">
    <Popup />
    <RouterView :class="{ 'no-footer': !matchRoutes }" />
    <Topbar />
    <KycFooter v-if="matchRoutes" />
    <Transition name="cookies">
      <CookieBanner v-if="cookiesBanner && !$route.meta.allowNoCookie" @cookie-agreement="cookieAgreement" />
    </Transition>
    <Transition name="cookies">
      <RGPDModal v-if="rgpdModal && !$route.meta.allowNoCookie" @rgpd-agreed="rgpdAgreed" />
    </Transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CookieBanner from '@/components/CookieBanner.vue';
import KycFooter from '@/components/KycFooter.vue';
import Popup from '@/components/popup';
import RGPDModal from '@/components/RgpdModal.vue';
import Topbar from '@/components/Topbar.vue';

export default {
  components: { Topbar, KycFooter, Popup, CookieBanner, RGPDModal },

  data() {
    return {
      cookiesBanner: true,
      rgpdModal: false,
    };
  },

  computed: {
    ...mapGetters(['user']),

    matchRoutes() {
      return this.$route.meta && this.$route.meta.footer;
    },
  },

  watch: {
    user(user) {
      if (user && user.id) {
        this.checkRGPD();
      }
    },
  },

  created() {
    const cookies = localStorage.getItem('KYCCookies') || localStorage.getItem('KYCCookiesRefused');
    const date = new Date(cookies);
    const cookiesYear = date.getFullYear();
    const cookiesMonth = date.getMonth();
    const cookiesDay = date.getDate();
    const expirationDate = new Date(cookiesYear + 1, cookiesMonth + 1, cookiesDay);
    if (cookies && expirationDate > new Date()) {
      this.cookiesBanner = false;
    } else {
      localStorage.removeItem('KYCCookies');
      localStorage.removeItem('KYCCookiesRefused');
    }
  },

  mounted() {
    if (this.user && this.user.id) {
      this.checkRGPD();
    }
  },

  methods: {
    cookieAgreement(agreement) {
      this.cookiesBanner = false;
      if (agreement) {
        localStorage.setItem('KYCCookies', new Date());
        localStorage.removeItem('KYCCookiesRefused');
      } else {
        localStorage.setItem('KYCCookiesRefused', new Date());
        localStorage.removeItem('KYCCookies');
      }
    },

    async rgpdAgreed() {
      await this.$store.dispatch('patchLegalAcceptance', {
        legalAccepted: true,
      });
      this.$store.dispatch('getUser');
      this.rgpdModal = false;
    },

    checkRGPD() {
      if (this.user.id && !this.user.legalAccepted) {
        this.rgpdModal = true;
      }
    },
  },
};
</script>

<style lang="scss">
.no-footer {
  height: calc(100vh);
}

.no-scroll {
  height: 100vh;
  overflow: hidden;
}

body {
  padding: 0;
}

.cookies-enter,
.cookies-leave-to {
  opacity: 0;
}
.cookies-enter-active,
.cookies-leave-active {
  transition: all 0.4s ease;
}
</style>
